import { Heading } from 'components/Heading';
import SalonContact from 'components/SalonContact/SalonContact';

import { useBusiness } from 'hooks/business/useBusiness';
import { usePreferences } from 'hooks/preferences/usePreferences';

import s from './NoServices.module.css';

export const NoServices = () => {
  const { promptForContactOnBooking } = usePreferences();
  const { email, phone, cellPhone } = useBusiness();

  return (
    <article className={s.root}>
      <Heading as="h3" className={s.title}>
        No services available
      </Heading>
      <p>Please check back later or contact us for more information</p>
      {promptForContactOnBooking && (
        <SalonContact
          businessEmail={email}
          businessPhone={phone}
          cellPhone={cellPhone}
        />
      )}
    </article>
  );
};
